export default __webpack_public_path__ + "a34f5324e95f40c206f0db852a732dd7.png";